/**
 * واتساب — every WhatsApp screen of the system in one page (owner, 2026-09-28: "اي حاجة تخص واتساب في السيستم كله
 * تبقى في صفحة واحدة … التابات القديمة هتنقلها في الصفحة الجديدة"). تحليل واتساب stays under التحليلات.
 *
 * Each screen keeps its page id, so its permission and صلاحيات المستخدمين setting still decide who sees it; its old
 * address opens it here (router.tsx).
 */
export interface HubTab {
  key: string; ar: string; en: string; pages: string[]
  /** marked new in the tab strip for 7 days */
  newSince?: string
  /** pages that are not inside the hub but belong next to this tab: shown as links that open them */
  links?: string[]
}

export const WHATSAPP_HUB: HubTab[] = [
  { key: 'chats', ar: 'المحادثات', en: 'Conversations', pages: ['cs.whatsapp', 'cs.shipmentChat', 'cs.courierChats'] },
  // لوحة الواتساب moved in (owner, 2026-10-29: one WhatsApp home): the numbers, every group message, the waiting queues
  { key: 'console', ar: 'الأرقام والإرسال', en: 'Numbers & sending', pages: ['settings.waConsole'], newSince: '2026-10-29' },
  { key: 'messages', ar: 'الرسائل', en: 'Messages', pages: ['integrations.whatsappMessages', 'aliensCourier.whatsappFailures', 'aliensCourier.shipmentTimeline', 'operations.receiptAudit'] },
  { key: 'customers', ar: 'رسائل العملاء', en: 'Customer messages', pages: ['integrations.consigneeMessages', 'aliensCourier.confirmations', 'aliensCourier.rules'] },
  { key: 'groups', ar: 'الجروبات', en: 'Groups', pages: ['aliensCourier.groupBroadcast'] },
  { key: 'settings', ar: 'الإعدادات', en: 'Settings', pages: ['settings.whatsapp', 'aliensCourier.whatsapp'], links: ['settings.notificationsHub'] },
  // every screen where a message template is edited, listed in one place (owner, 2026-10-29)
  { key: 'templates', ar: 'القوالب', en: 'Templates', pages: ['cs.whatsappTemplates'], newSince: '2026-10-29' },
]

/** The hub's own address; `wa` names the screen (a name no inner screen uses for itself). */
export const HUB_PATH = '/whatsapp'
export const HUB_PARAM = 'wa'

/** The pages that moved here. */
export const HUB_PAGE_IDS = new Set(WHATSAPP_HUB.flatMap((t) => t.pages))
// integrations.whatsapp was the same screen as cs.whatsapp under a second name; its entry is gone (2026-10-29), an old
// link naming it still opens the conversations
const ALIAS: Record<string, string> = { 'integrations.whatsapp': 'cs.whatsapp' }

/** The hub address for one of its screens, keeping that screen's own query (?awb=…). */
export function hubUrl(pageId: string, search = ''): string {
  const q = new URLSearchParams(search)
  q.delete(HUB_PARAM)
  const rest = q.toString()
  return `${HUB_PATH}?${HUB_PARAM}=${encodeURIComponent(ALIAS[pageId] ?? pageId)}${rest ? `&${rest}` : ''}`
}

export const tabOf = (pageId: string) => WHATSAPP_HUB.find((t) => t.pages.includes(ALIAS[pageId] ?? pageId)) ?? null
